export default __webpack_public_path__ + "static/media/homelogo.496f2e67.svg";